
















































import { Component } from 'vue-property-decorator';
import { AgencyModel, AgencyStatus, AgencyType, Factory } from 'admiral-core';
import { CalendarIcon, CircleIcon, DiscIcon, XIcon } from 'vue-feather-icons';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import { FormMixin } from '@/mixins/FormMixin';
import AgencyForm from '@/forms/AgencyForm.vue';
import { Util } from '@/utils/Util';
import { AgencyApi } from '@/services/AgencyApi';
import { BModal } from 'bootstrap-vue';
import FormSubmit from '@/components/common/forms/FormSubmit.vue';

@Component({
  components: {
    FormSubmit,
    AgencyForm,
    CircleIcon,
    DiscIcon,
    CalendarIcon,
    XIcon,
  },
})
export default class CreateAgencyModal extends mixins(BaseMixin, FormMixin) {
  model = this.defaultModel();

  productOptions: string[] = [
    'Baufinanzierung',
    'Unfall',
    'Leben KnP',
    'Kranken MB',
    'P-Sach o. Kr.',
    'Bausparen',
    'Fonds',
    'Leben',
    'Firmen',
    'Kraft',
    'Sonstiges',
    'Risikoleben',
  ];

  businessPlanGoalsOptions: string[] = [
    'VAG: Leben KnP_PfEK-V NSt',
    'Unfall Bew o. Anp. Digi',
    'F-Sach o. Kraft Bew',
    'Bausparen Neustück',
    'P-Sach o.Kr./U BZUW-BT',
    'Kranken Zusatz Bew',
    'Fonds Bewertung',
    'VAG:Leben KnP Bew',
    'VAG:Rente/Leben BewoZE',
    'P-Sach o.K/U Bew. Digi',
    'Bausparen Bewertung',
    'KH-PkW LfNST Digi',
    'Gesamtbewertung',
  ];

  competitionsHessClubGoalsOptions: string[] = [
    'EH Gesamtbewertung',
    'Gesamtbewertung',
    'P-Sach Bew. Digi',
    'Leben Bewertung ohne ZE',
    'Kranken Bew o. Dyn.',
  ];

  competitionsRingGoalsOptions: string[] = [
    'EH Gesamtbewertung',
    'GP EH Sach Bewertung',
    'Unfall Bew o. Anp. Digi',
    'P-Sach o.K/U Bew. Digi',
    'KH-PkW LfNST Digi',
    'F-Sach o. Kraft Bew',
    'VAG:Rente/Leben BewoZE',
    'VAG:Leben KnP Bew',
    'Fonds Bewertung',
    'Kranken Bew o. Dyn.',
  ];

  selectedProducts: string[] = [];
  selectedBusinessPlanGoals: string[] = [];
  selectedCompetitionsHessClubPlanGoals: string[] = [];
  selectedCompetitionsRingPlanGoals: string[] = [];
  defaultModel(): AgencyModel {
    return {
      name: '',
      status: AgencyStatus.DEMO,
      type: AgencyType.GENERIC,
      notes: '',
      plan: Factory.buildCorePlan(),
      identifier: '',
      startedAt: new Date(),
      endsAt: Util.formatAgencyStatusEndsAt(new Date(), AgencyStatus.DEMO),
      moduleAntragsbuch: true,
      moduleGoals: true,
      moduleStatistics: true,
    };
  }

  async mounted() {
    this.model = { ...this.defaultModel() };

    this.selectedProducts = [...this.productOptions];

    this.selectedBusinessPlanGoals = [...this.businessPlanGoalsOptions];
    this.selectedCompetitionsHessClubPlanGoals = [...this.competitionsHessClubGoalsOptions];
    this.selectedCompetitionsRingPlanGoals = [...this.competitionsRingGoalsOptions];
  }

  async ok(evt: Event) {
    evt.preventDefault();
    try {
      this.isLoading = true;

      await AgencyApi.create({
        name: this.model.name!,
        status: this.model.status!,
        type: this.model.type!,
        plan: this.model.plan!,
        endsAt: this.model.endsAt!,
        identifier: this.model.identifier!,
        notes: this.model.notes!,
        startedAt: this.model.startedAt!,
        products: this.selectedProducts!,
        goals: this.selectedBusinessPlanGoals!,
        moduleAntragsbuch: this.model.moduleAntragsbuch!,
        moduleStatistics: this.model.moduleStatistics!,
        moduleGoals: this.model.moduleGoals!,
      });

      this.model = { ...this.defaultModel() };
      this.$emit('reload');
      this.$nextTick(() => {
        (this.$refs['create-agency'] as BModal).hide();
      });
    } catch (e) {
      const apiErrors = this.exceptionErrors(e);

      this.errorHandling(apiErrors);
      this.$toastr.e('Beim Speichern der Aufgabe ist etwas schief gelaufen.', 'Oops');
      throw e;
    } finally {
      this.isLoading = false;
    }
  }

  errorHandling(apiErrors: Record<string, string>) {
    this.addError(apiErrors['nameisNotEmpty'], 'name', 'Bitte einen gültigen Namen eingeben.');

    this.addError(
      apiErrors['identifierisNotEmpty'],
      'identifier',
      'Bitte eine gültige ID eingeben',
    );

    this.addError(apiErrors['Existing'], 'identifier', 'Agentur existiert bereits');
  }

  async cancel() {
    this.model = { ...this.defaultModel() };
  }
}
